export function base64ToFile(base64: string, fileName: string): File {
	const arr = base64.split(',');
	const mimeMatch = arr[0].match(/:(.*?);/);
	const mime = mimeMatch ? mimeMatch[1] : '';
	const bstr = atob(arr[1]);
	let n = bstr.length;
	const u8arr = new Uint8Array(n);
  
	while (n--) {
	  u8arr[n] = bstr.charCodeAt(n);
	}
  
	return new File([u8arr], fileName, { type: mime });
  }
  
  export const blobToFile = (blob: Blob, fileName: string): File => {
	return new File([blob], fileName, {
	  type: blob.type,
	  lastModified: Date.now(),
	});
  };